import { CloseOutlined } from '@ant-design/icons';
import bladeStyles from './Blade.module.css';

interface BladeHeaderProps {
  title: string;
  onClose: () => void;
}

const BladeHeader = ({ title, onClose }: BladeHeaderProps) => (
  <div className={bladeStyles.header}>
    <h2 className={bladeStyles.headerTitle} data-testid="blade-title">{title}</h2>
    <button className={bladeStyles.closeButton} onClick={onClose} aria-label="Close" data-testid="blade-close-button">
      <CloseOutlined />
    </button>
  </div>
);

export default BladeHeader;
